// color codes for statuses
// TODO: Rename this bunch and redo the colors properly
export const STATUS_STYLES = {
  // order statuses
  processing: { label: "Processing", color: "bg-yellow-100 text-yellow-800" },
  delivered: { label: "Delivered", color: "bg-green-100 text-green-800" },
  cancelled: { label: "Cancelled", color: "bg-red-100 text-red-800" },
  completed: { label: "Completed", color: "bg-green-100 text-green-800" },
  "on delivery": { label: "On Delivery", color: "bg-blue-100 text-blue-800" },
  "in review": { label: "In Review", color: "bg-blue-100 text-blue-800" },
  "awaiting pickup": { label: "Awaiting Pickup", color: "bg-blue-100 text-blue-800" },

  // product statuses
  active: { label: "Active", color: "bg-green-100 text-green-800 font-semibold rounded-full" },
  draft: { label: "Draft", color: "bg-gray-100 text-gray-800 font-semibold rounded-full" },
  archived: { label: "Archived", color: "bg-red-100 text-red-800 font-semibold rounded-full" },
  unknown: { label: "Unknown", color: "bg-gray-100 text-gray-800 font-semibold rounded-full" },
};

// colored text for inventory status
export const INVENTORY_STYLES = {
  none: { color: "text-red-500 font-medium" },
  low: { color: "text-yellow-600 font-medium" },
  normal: { color: "text-green-600 font-medium" },
};

// Payment statuses
export const PAYMENT_STATUS_STYLES = {
  paid: { label: "Paid", color: "bg-green-100 text-green-800" },
  unpaid: { label: "Unpaid", color: "bg-red-100 text-red-800" },
  pending: { label: "Pending", color: "bg-yellow-100 text-yellow-800" },
  failed: { label: "Failed", color: "bg-red-200 text-red-900" },
  refunded: { label: "Refunded", color: "bg-blue-100 text-blue-800" },
  unknown: { label: "Unknown", color: "bg-gray-100 text-gray-800" },
};

export const DISCOUNT_STATUS_STYLES = {
  active: { label: "Active", color: "bg-green-100 text-green-800 font-semibold rounded-md" },
  scheduled: { label: "Scheduled", color: "bg-blue-100 text-blue-800 font-semibold rounded-md" },
  expired: { label: "Expired", color: "bg-red-100 text-red-600 font-semibold rounded-md" },
  unknown: { label: "Unknown", color: "bg-gray-100 text-gray-800 font-semibold rounded-md" },
};

// Order fulfillment statuses
export const ORDER_FULFILLMENT = {
  processing: {
    label: "Processing",
    color: "bg-[#ffefb0] text-[#92400E]", // amber yellow
  },
  onDelivery: {
    label: "On Delivery",
    color: "bg-[#ceebff] text-[#0369A1]", // blue
  },
  awaitingPickup: {
    label: "Awaiting Pickup",
    color: "bg-[#ceebff] text-[#0369A1]", // blue
  },
  inReview: {
    label: "In Review",
    color: "bg-[#ceebff] text-[#0369A1]", // blue
  },
  delivered: {
    label: "Delivered",
    color: "bg-[#DCFCE7] text-[#166534]", // green
  },
  completed: {
    label: "Completed",
    color: "bg-[#DCFCE7] text-[#166534]", // green
  },
  cancelled: {
    label: "Cancelled",
    color: "bg-[#FECACA] text-[#991B1B]", // red
  },
};

// Order payment statuses
export const ORDER_PAYMENT = {
  paid: {
    label: "Paid",
    color: "bg-[#DCFCE7] text-[#166534]", //green
  },
  pending: {
    label: "Pending",
    color: "bg-[#ffefb0] text-[#92400E]", // amber yellow
  },
  failed: {
    label: "Failed",
    color: "bg-[#FECACA] text-[#991B1B]", // red
  },
  refunded: {
    label: "Refunded",
    color: "bg-[#ceebff] text-[#0369A1]", // blue
  },
  partiallyRefunded: {
    label: "Partially Refunded",
    color: "bg-[#ceebff] text-[#0C4A6E]", // darker blue
  },
  partiallyPaid: {
    label: "Partially Paid",
    color: "bg-[#FEF9C3] text-[#92400E]", // amber yellow
  },
  unpaid: {
    label: "Unpaid",
    color: "bg-[#e7e7e7] text-[#333333]", // grey
  },
  cancelled: {
    label: "Cancelled",
    color: "bg-[#FECACA] text-[#991B1B]", // red
  },
};

// Order lifecycle statuses
export const ORDER_STATUS_STYLES = {
  active: {
    label: "Active",
    color: "bg-[#DCFCE7] text-[#166534]", // green
  },
  archived: {
    label: "Archived",
    color: "bg-[#e7e7e7] text-[#333333]", // grey
  },
  draft: {
    label: "Draft",
    color: "bg-[#e7e7e7] text-[#333333]", // grey
  },
};

// Transaction types (POS ledger entries)
export const TRANSACTION_TYPE = {
  sale: { label: "Sale", color: "bg-[#DCFCE7] text-[#166534]" }, // green
  refund: { label: "Refund", color: "bg-[#FECACA] text-[#991B1B]" }, // red
  payout: { label: "Payout", color: "bg-[#ceebff] text-[#0369A1]" }, // blue
  unknown: { label: "Other", color: "bg-[#e7e7e7] text-[#333333]" },
};

// Transaction states
export const TRANSACTION_STATUS = {
  completed: { label: "Completed", color: "bg-[#DCFCE7] text-[#166534]" },
  pending: { label: "Pending", color: "bg-[#ffefb0] text-[#92400E]" },
  voided: { label: "Voided", color: "bg-[#FECACA] text-[#991B1B]" },
  unknown: { label: "Unknown", color: "bg-[#e7e7e7] text-[#333333]" },
};

// Shift statuses
export const SHIFT_STATUS = {
  open: { label: "Open", color: "bg-[#ffefb0] text-[#92400E]" }, // amber - still running
  verified: { label: "Verified", color: "bg-[#DCFCE7] text-[#166534]" }, // green
  closed: { label: "Closed", color: "bg-[#ceebff] text-[#0369A1]" }, // blue - closed, unverified
  unknown: { label: "Unknown", color: "bg-[#e7e7e7] text-[#333333]" },
};

// Expense workflow states
export const EXPENSE_STATE = {
  draft: { label: "Draft", color: "bg-[#e7e7e7] text-[#333333]" },
  submitted: { label: "Submitted", color: "bg-[#ffefb0] text-[#92400E]" },
  approved: { label: "Approved", color: "bg-[#DCFCE7] text-[#166534]" },
  rejected: { label: "Rejected", color: "bg-[#FECACA] text-[#991B1B]" },
  cancelled: { label: "Cancelled", color: "bg-[#FECACA] text-[#991B1B]" },
  unknown: { label: "Unknown", color: "bg-[#e7e7e7] text-[#333333]" },
};

// Expense payment statuses
export const EXPENSE_PAYMENT = {
  paid: { label: "Paid", color: "bg-[#DCFCE7] text-[#166534]" },
  partiallyPaid: { label: "Partially Paid", color: "bg-[#FEF9C3] text-[#92400E]" },
  payable: { label: "Payable", color: "bg-[#e7e7e7] text-[#333333]" },
  overdue: { label: "Overdue", color: "bg-[#FECACA] text-[#991B1B]" },
  writtenOff: { label: "Written Off", color: "bg-[#ceebff] text-[#0369A1]" },
  unknown: { label: "Unknown", color: "bg-[#e7e7e7] text-[#333333]" },
};

